import arrowDown from "./images/icon-arrow-down.svg";
import arrowUp from "./images/icon-arrow-up.svg";
import SubCompanyList from "./SubCompanyList";
import SubFeatures from "./SubFeatures";
const Navigation = ({ subCompanyList, subFeatures, handleClick }) => {
  return (
    <>
      <div className="navbar">
        <ul>
          <li>
            <button value="features" onClick={handleClick}>
              features
              {<img src={subFeatures ? arrowUp : arrowDown} alt="features" />}
            </button>
          </li>
          <li>
            <button value="company" onClick={handleClick}>
              company
              {<img src={subCompanyList ? arrowUp : arrowDown} alt="company" />}
            </button>
          </li>
          <li>
            <button onClick={handleClick}>careers</button>
          </li>
          <li>
            <button onClick={handleClick}>about</button>
          </li>
        </ul>
        <div className="btn-container">
          <button onClick={handleClick}>login</button>
          <button onClick={handleClick} className="register-btn">
            register
          </button>
        </div>
      </div>
      <SubFeatures subFeatures={subFeatures} />
      <SubCompanyList subCompanyList={subCompanyList} />
    </>
  );
};

export default Navigation;
